import React from "react";
import { Link } from "react-router-dom";
import "./PageNotFound.css";

function PageNotFound() {
  return (
    <div className="notfound-page">
      <section className="notfound-hero">
        {/* Decorative Circles */}
        <div className="notfound-circle notfound-circle-1" />
        <div className="notfound-circle notfound-circle-2" />
        <div className="notfound-circle notfound-circle-3" />
        <div className="notfound-circle notfound-circle-4" />

        <div className="notfound-content" data-aos="fade-up">
          <span className="notfound-tag">
            <i className="ri-bread-line"></i> Royal Bakery
          </span>

          <div className="notfound-number" aria-hidden="true">
            <span className="notfound-digit">4</span>
            <span className="notfound-dot">
              <i className="ri-bread-line"></i>
            </span>
            <span className="notfound-digit">4</span>
          </div>

          <h1>Oops! This Page Is <span>Freshly Gone</span></h1>
          <p className="notfound-desc">
            The page you're looking for seems to have crumbled away or moved
            somewhere else. Don't worry — there's plenty more baked fresh to enjoy.
          </p>

          <div className="notfound-actions">
            <Link to="/" className="notfound-btn notfound-btn-primary">
              <i className="ri-home-4-line"></i> Back to Home
            </Link>
            <Link to="/products" className="notfound-btn notfound-btn-outline">
              Explore Products <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="notfound-links" data-aos="fade-up" data-aos-delay="150">
          <span>You might be looking for:</span>
          <Link to="/about">About Us</Link>
          <Link to="/products">Products</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/inquiry">Bulk Inquiry</Link>
        </div>
      </section>
    </div>
  );
}

export default PageNotFound;